import http from '../httpClient';
import { getTokenString } from '../tokenService';

/**
 * Ендпоінти інтеграції eObig (ЕДО).
 * Секція бекенду: `eobig` -> actions/company/eobig/<action>.php.
 * Токен eObig зберігається лише на бекенді (у картці ФОП/ТОВ), у ці запити не потрапляє.
 */
function buildBaseParams() {
  const tcs = getTokenString();
  if (!tcs) return null;

  const token = tcs.split('&')[0];
  const companyId = new URLSearchParams(tcs.split('&').slice(1).join('&')).get('companyId');

  if (!token || token.toLowerCase?.() === 'null' || !companyId) return null;

  return { section: 'eobig', token, companyId };
}

/**
 * Надіслати рахунок клієнту через eObig.
 * @param {string|number} documentId — id рахунку (документа)
 * @param {{ email: string, comment?: string }} payload — пошта клієнта (вручну) + коментар
 */
export const sendInvoice = (documentId, payload) => {
  const baseParams = buildBaseParams();
  if (!baseParams) return Promise.reject(new Error('auth-missing'));

  return http.post('/', payload, { params: { action: 'sendInvoice', documentId, ...baseParams } });
};

/**
 * Надіслати видаткову накладну клієнту через eObig (лише для оплаченого рахунку).
 * @param {string|number} documentId
 * @param {{ email: string, comment?: string }} payload
 */
export const sendWaybill = (documentId, payload) => {
  const baseParams = buildBaseParams();
  if (!baseParams) return Promise.reject(new Error('auth-missing'));

  return http.post('/', payload, { params: { action: 'sendWaybill', documentId, ...baseParams } });
};

/**
 * «Підписати та надіслати»: завантажити документ у eObig, додати клієнта і отримати
 * гостьове sign-посилання для нашого КЕП-підпису (фронт відкриває його у модалці).
 * @param {string|number} documentId
 * @param {{ docType: 'invoice'|'waybill', email: string, comment?: string, redirectUrl?: string }} payload
 */
export const signAndSend = (documentId, payload) => {
  const baseParams = buildBaseParams();
  if (!baseParams) return Promise.reject(new Error('auth-missing'));

  return http.post('/', payload, { params: { action: 'signAndSend', documentId, ...baseParams } });
};

/**
 * Підписати емітента на вебхуки eObig (одноразове налаштування, admin).
 * @param {string|number} providerId
 */
export const subscribeWebhook = (providerId) => {
  const baseParams = buildBaseParams();
  if (!baseParams) return Promise.reject(new Error('auth-missing'));

  return http.post('/', {}, { params: { action: 'subscribeWebhook', providerId, ...baseParams } });
};

/**
 * Отримати актуальний статус документа eObig.
 * @param {string|number} providerId — емітент (ФОП/ТОВ)
 * @param {string|number} docId — id документа в eObig
 */
export const getDocStatus = (providerId, docId) => {
  const baseParams = buildBaseParams();
  if (!baseParams) return Promise.reject(new Error('auth-missing'));

  return http.get('/', { params: { action: 'getDocStatus', providerId, docId, ...baseParams } });
};
